var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38368",
    "data-name": "Group 38368",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.793,
    height: 33.718,
    viewBox: "0 0 35.793 33.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.845,0l8.948,16.859L26.845,33.718H8.948L0,16.859,8.948,0Z",
    transform: "translate(0 0)",
    fill: "#c3288a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "course-management-2",
    transform: "translate(9.831 10.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64990",
    "data-name": "Path 64990",
    d: "M577.247,13.5a.619.619,0,0,1-.332-.1,6.34,6.34,0,0,0-6.767,0,.621.621,0,0,1-.953-.524V1.788a.62.62,0,0,1,.288-.524,7.556,7.556,0,0,1,8.1,0,.62.62,0,0,1,.288.524V12.882A.621.621,0,0,1,577.247,13.5ZM570.436,2.138v9.706a7.557,7.557,0,0,1,6.19,0V2.138A6.348,6.348,0,0,0,570.436,2.138Z",
    transform: "translate(-561.737 -0.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64991",
    "data-name": "Path 64991",
    d: "M8.053,13.5a.619.619,0,0,1-.333-.1,6.34,6.34,0,0,0-6.767,0A.621.621,0,0,1,0,12.884V1.79a.621.621,0,0,1,.288-.524,7.556,7.556,0,0,1,8.1,0,.621.621,0,0,1,.288.524V12.884A.621.621,0,0,1,8.053,13.5ZM4.336,11.184a7.543,7.543,0,0,1,3.1.663V2.14a6.346,6.346,0,0,0-6.191,0v9.706A7.543,7.543,0,0,1,4.336,11.184Z",
    transform: "translate(0 -0.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64992",
    "data-name": "Path 64992",
    d: "M169.954,53.536h-2.715a.621.621,0,0,1,0-1.241h2.715a.621.621,0,1,1,0,1.241Zm0,2.767h-2.715a.621.621,0,0,1,0-1.241h2.715a.621.621,0,1,1,0,1.241Zm7.422-3.52a.621.621,0,0,1-.349-.108l-.849-.579-.85.579a.621.621,0,0,1-.97-.513v-3.34a.621.621,0,0,1,1.241,0v2.166l.229-.155a.621.621,0,0,1,.7,0l.229.155V48.822a.621.621,0,0,1,1.241,0v3.34a.621.621,0,0,1-.621.621Z",
    transform: "translate(-164.435 -47.571)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIcon);
export default __webpack_public_path__ + "static/media/courseIcon.30c0d2218516655ad6e43e97e076fdd2.svg";
export { ForwardRef as ReactComponent };